import {
  Container,
  Grid,
  Box,
  Button,
  Slide,
  Paper,
  Typography,
  useTheme,
  Snackbar,
  makeStyles,IconButton,Tooltip
} from "@material-ui/core";
import { useState, useEffect } from "react";
import parse from "html-react-parser";
import Axios from "axios";
import LinkIcon from '@material-ui/icons/Link';
import { Helmet } from "react-helmet-async";

import { Loading } from "../../components/shared/loading";

import PhoneIcon from "@material-ui/icons/Phone";

import { Link, useParams } from "react-router-dom";

import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon,
 // RedditShareButton,
 // RedditIcon,
  XIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
 // ViberShareButton,
  WhatsappShareButton,
  WhatsappIcon,RedditIcon, RedditShareButton
  
} from "react-share";
import MuiAlert from "@material-ui/lab/Alert";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    position: "relative",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9))",
    },
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  pageWrapper: {
    background: "#f5f3f6",
    paddingTop: 0,
    paddingBottom: 60,
  },
  backLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: "0.78rem",
    color: "#6b1b6b",
    fontWeight: 500,
    textDecoration: "none",
    padding: "20px 0 16px",
    transition: "all 0.2s ease",
    "&:hover": {
      textDecoration: "none",
      color: "#4c004c",
      gap: 10,
    },
  },
  contentContainer: {
    background: "#ffffff",
    borderRadius: 24,
    boxShadow: "0 8px 40px rgba(0,0,0,0.05)",
    overflow: "hidden",
  },
  // Image Gallery
  imageSection: {
    position: "relative",
    width: "100%",
    background: "#0a0a0a",
    overflow: "hidden",
  },
  serviceImage: {
    width: "100%",
    height: 360,
    objectFit: "contain",
    display: "block",
    padding: 20,
    [theme.breakpoints.down('sm')]: {
      height: 240,
      padding: 12,
    },
  },
  imageOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 80,
    background: "linear-gradient(transparent, rgba(10,10,10,0.6))",
    pointerEvents: "none",
  },
  // Service Meta
  serviceMeta: {
    padding: "28px 32px 20px",
    [theme.breakpoints.down('sm')]: {
      padding: "24px 20px 16px",
    },
  },
  serviceTitle: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: 6,
    letterSpacing: "0.2px",
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.1rem",
    },
  },
  serviceTagline: {
    fontSize: "0.82rem",
    color: "#888888",
    lineHeight: 1.5,
    fontWeight: 400,
  },
  // Share
  shareBar: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "14px 32px",
    borderTop: "1px solid rgba(76,0,76,0.04)",
    borderBottom: "1px solid rgba(76,0,76,0.04)",
    [theme.breakpoints.down('sm')]: {
      padding: "12px 20px",
      gap: 8,
    },
  },
  shareLabel: {
    fontSize: "0.72rem",
    fontWeight: 600,
    color: "#999",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginRight: 4,
  },
  shareBtn: {
    transition: "all 0.2s ease",
    opacity: 0.7,
    "&:hover": {
      opacity: 1,
      transform: "scale(1.12)",
    },
  },
  // Content
  serviceContent: {
    padding: "32px 32px 40px",
    [theme.breakpoints.down('sm')]: {
      padding: "24px 20px 32px",
    },
  },
  serviceBody: {
    fontSize: "0.95rem",
    color: "#2a2a2a",
    lineHeight: 1.9,
    fontWeight: 400,
    "& p": {
      marginBottom: 20,
    },
    "& ul, & ol": {
      paddingLeft: 24,
      marginBottom: 20,
    },
    "& li": {
      marginBottom: 10,
    },
    "& h1, & h2, & h3, & h4": {
      color: "#4c004c",
      fontWeight: 600,
      marginTop: 32,
      marginBottom: 14,
    },
    "& img": {
      maxWidth: "100%",
      borderRadius: 12,
      margin: "24px 0",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    },
    "& a": {
      color: "#6b1b6b",
      textDecoration: "none",
      borderBottom: "1px solid rgba(107,27,107,0.3)",
      transition: "border-color 0.2s ease",
      "&:hover": {
        borderColor: "#6b1b6b",
      },
    },
    "& blockquote": {
      borderLeft: "3px solid #6b1b6b",
      margin: "24px 0",
      padding: "12px 20px",
      background: "rgba(107,27,107,0.03)",
      borderRadius: "0 8px 8px 0",
      fontStyle: "italic",
      color: "#555",
    },
  },
  // CTA
  ctaSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: 24,
    padding: "40px 28px",
    marginTop: 32,
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "radial-gradient(circle at 20% 80%, rgba(255,255,255,0.08) 0%, transparent 50%)",
      pointerEvents: "none",
    },
  },
  ctaLabel: {
    fontSize: "0.68rem",
    fontWeight: 600,
    color: "rgba(255,255,255,0.5)",
    textTransform: "uppercase",
    letterSpacing: "2px",
    marginBottom: 12,
    position: "relative",
    zIndex: 1,
  },
  ctaTitle: {
    fontSize: "1.15rem",
    color: "#ffffff",
    fontWeight: 300,
    marginBottom: 24,
    lineHeight: 1.4,
    maxWidth: 400,
    margin: "0 auto 24px",
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: "1rem",
    },
  },
  ctaButton: {
    backgroundColor: "rgba(255,255,255,0.12)",
    backdropFilter: "blur(8px)",
    color: "#ffffff",
    padding: "12px 32px",
    fontSize: "0.82rem",
    fontWeight: 500,
    borderRadius: 14,
    textTransform: "none",
    border: "1px solid rgba(255,255,255,0.15)",
    transition: "all 0.3s ease",
    position: "relative",
    zIndex: 1,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
    },
  },
}));


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export const ServiceDetails = () => {
  const classes = useStyles();
  const theme = useTheme();
  let { id } = useParams();
  const url=window.location.href;
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);
  const [service, setService] = useState(true);


  const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("success");
  const [snackBarType, setSnackBarType] = useState("Invalid");

  const openSnkbar = (type, msg) => {
    setSnackBarMsg(msg);
    setSnackBarType(type);
    setSnackBar(true);
  };


  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };


  const [tooltipText, setTooltipText] = useState("Click to copy the URL");

  const handleCopy = () => {
    // Copy the URL to clipboard
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        setTooltipText("Link copied to clipboard!"); // Update tooltip text
        setTimeout(() => setTooltipText("Click to copy the URL"), 2000); // Reset tooltip text after 2 seconds
      })
      .catch((err) => console.error("Failed to copy: ", err));
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("id", id);

    Axios.post("/api/getsingleservice", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.serv_title);
        setMetaKeywords(res.data.data.serv_keywords);
        setMetaDesc(res.data.data.serv_metadesc);
        setService(res.data.data);
        setIsloading(false);
        handleClick();
      }
    });
  };

  return (
    <div>
      {service && !isloading ? (
        <div>
          <Helmet>
            <title>{metaTitle + " | Arawinz Soft Solutions"}</title>
            <meta name="description" content={metaDesc} />
            <meta name="keywords" content={metaKeywords}></meta>
          </Helmet>

          {/* Hero Section */}
          <Box 
            className={classes.heroSection}
            style={{ backgroundImage: `url("/static/services/${service.serv_image}")` }}
          >
            <Box className={classes.heroContent}>
              <Typography className={classes.heroTitle}>
                {service.serv_name}
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                Professional IT Solutions by Arawinz
              </Typography>
            </Box>
          </Box>

          {/* Content Section */}
          <Box className={classes.pageWrapper}>
            <Container maxWidth="md">
              {/* Back Link */}
              <Link to="/our-services" className={classes.backLink}>
                ← Back to Services
              </Link>

              {/* Service Card */}
              <Box className={classes.contentContainer}>
                {/* Image Section */}
                <Box className={classes.imageSection}>
                  <img
                    src={`/static/services/${service.serv_image}`}
                    alt={service.serv_name}
                    className={classes.serviceImage}
                  />
                  <Box className={classes.imageOverlay} />
                </Box>

                {/* Meta Section */}
                <Box className={classes.serviceMeta}>
                  <Typography className={classes.serviceTitle}>
                    {service.serv_name}
                  </Typography>
                  <Typography className={classes.serviceTagline}>
                    Expert solutions tailored to your business needs
                  </Typography>
                </Box>

                {/* Share Bar */}
                <Box className={classes.shareBar}>
                  <Typography className={classes.shareLabel}>Share</Typography>
                  <FacebookShareButton url={url} className={classes.shareBtn}>
                    <FacebookIcon size={26} round />
                  </FacebookShareButton>
                  <LinkedinShareButton url={url} className={classes.shareBtn}>
                    <LinkedinIcon size={26} round />
                  </LinkedinShareButton>
                  <TwitterShareButton url={url} className={classes.shareBtn}>
                    <XIcon size={26} round />
                  </TwitterShareButton>
                  <WhatsappShareButton url={url} className={classes.shareBtn}>
                    <WhatsappIcon size={26} round />
                  </WhatsappShareButton>
                  <TelegramShareButton url={url} className={classes.shareBtn}>
                    <TelegramIcon size={26} round />
                  </TelegramShareButton>
                  <EmailShareButton url={url} className={classes.shareBtn}>
                    <EmailIcon size={26} round />
                  </EmailShareButton>
                  <Tooltip title={tooltipText} arrow>
                    <IconButton onClick={handleCopy} size="small" style={{ opacity: 0.6 }}>
                      <LinkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Service Content */}
                <Box className={classes.serviceContent}>
                  <Box className={classes.serviceBody}>
                    {parse(service.serv_desc)}
                  </Box>
                </Box>
              </Box>

              {/* CTA Section */}
              <Box className={classes.ctaSection}>
                <Typography className={classes.ctaLabel}>
                  Interested?
                </Typography>
                <Typography className={classes.ctaTitle}>
                  Let's discuss how we can help your business grow
                </Typography>
                <Button
                  component={Link}
                  to="/get-in-touch"
                  className={classes.ctaButton}
                  startIcon={<PhoneIcon style={{ fontSize: 18 }} />}
                >
                  Get in Touch
                </Button>
              </Box>

              {/* Snackbar */}
              <Snackbar
                open={snackBar}
                autoHideDuration={4000}
                onClose={() => setSnackBar(false)}
              >
                <Alert
                  onClose={() => setSnackBar(false)}
                  severity={snackBarType}
                  style={{ color: snackBarType === "warning" ? "black" : "white" }}
                >
                  {snackBarMsg}
                </Alert>
              </Snackbar>
            </Container>
          </Box>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

